import * as SubmissionStatus from './SubmissionStatus'
import checkIcon from '../assests/LessonViewer/checkIcon.png'

export const StatusEnum = {
    [SubmissionStatus.notStarted]: {
        text: 'NotStarted',
        color: "#73DED8"
    },
    [SubmissionStatus.started]: {
        text: 'Started',
        color: "#73DED8"
    },
    [SubmissionStatus.submitted]: {
        text: 'Submitted',
        color: "#73DED8"
    },
    [SubmissionStatus.late]: {
        text: 'submittedLate',
        color: "#ED8068"
    },
    [SubmissionStatus.rejected]: {
        text: 'Rejected',
        color: "#FF9A03"
    },
    [SubmissionStatus.resubmitted]: {
        text: 'Resubmitted',
        color: "#FEF652"
    },
    [SubmissionStatus.completed]: {
        text: 'done',
        color: "#FEF652",
        icon: checkIcon
    },
    [SubmissionStatus.scored]: {
        text: 'scored',
        color: "#FEF652"
    },
    NoQuestionsAnswer: {
        // text: 'noQuestionsAnswer',
        color: "#DDDDDD"
    },
    SomeQuestionsAnswered: {
        // text: '  ',
        color: "#C1F3F3"
    },
    AllQuestionsAnswered: {
        text: 'done',
        color: "#FEF652"
    },
    Learning: {
        text: 'learningAssessment',
        color: "#DDB3F0"
    },
}